export default {
  isAdmin(state) {
    return !!state.user.groups.find(g => g.name == 'admin');
  },
  isSimpleUser(state) {
    return !!state.user.groups.find(g => g.name == 'simpleuser');
  }
}
